<div class="d-flex align-items-start">
  <div class="col-5 asset-card-content-title">{{ label }}</div>
  <div class="col-7 asset-card-content-value">
    <input
      type="text"
      class="form-control edit-input"
      [class.is-invalid]="!!error"
      [placeholder]="placeholder"
      [attr.maxlength]="maxLength ?? null"
      [(ngModel)]="inputValue"
      (ngModelChange)="onValueChange($event)"
    />
    <div *ngIf="error" class="invalid-feedback d-block">
      {{ error.key | translate: error.params }}
    </div>
  </div>
</div>
